import { render, staticRenderFns } from "./SnackbarNotification.vue?vue&type=template&id=4b2429ea&scoped=true"
import script from "./SnackbarNotification.vue?vue&type=script&lang=js"
export * from "./SnackbarNotification.vue?vue&type=script&lang=js"
import style0 from "./SnackbarNotification.vue?vue&type=style&index=0&id=4b2429ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_lodash@4.17.21_vue-template-compiler@2.7.16_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2429ea",
  null
  
)

export default component.exports